
export class AlertComment {

    id?: number;
    comments?: string;
    alertInstanceId?: number;
    alertRuleId?: string;
    userEmail?: string;
    userId?: number;
    commentTimestamp?: number;

    __displayTimestamp?: string;
}
